function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import withStyles from 'isomorphic-style-loader/withStyles';
import { FormattedMessage } from 'react-intl';
import moment from 'moment';
import PolygonIcon from 'svg/polygon.svg';
import InjectionIcon from 'svg/injection.svg';
import messages from '../messages';
import * as shapes from '../shapes';
import styles from './InjectionTooltip.pcss';
var _React_PureComponent;
class InjectionTooltip extends (_React_PureComponent = React.PureComponent) {
    renderTitle() {
        return /*#__PURE__*/ _jsxs("div", {
            className: styles.injectionTooltip__title,
            children: [
                /*#__PURE__*/ _jsx(InjectionIcon, {
                    className: styles.injectionTooltip__titleIcon
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: styles.injectionTooltip__titleText,
                    children: [
                        /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.injection.label)),
                        " (",
                        /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.injection.labels.injectionUnit)),
                        ")"
                    ]
                })
            ]
        });
    }
    renderInjection() {
        const { injection } = this.props;
        const type = injection.name === 'Long-acting Insulin' ? /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.injection.labels.longActing)) : /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.injection.labels.factActing));
        return /*#__PURE__*/ _jsxs("div", {
            className: styles.injectionTooltip__detail,
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: styles.injectionTooltip__detailType,
                    children: type
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: styles.injectionTooltip__detailValue,
                    children: injection.value
                })
            ]
        });
    }
    renderTime() {
        const { injection } = this.props;
        const time = moment.unix(injection.timestamp).utc().format('LT');
        return /*#__PURE__*/ _jsxs("div", {
            className: styles.injectionTooltip__detail,
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: styles.injectionTooltip__detailType,
                    children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.activity.labels.time))
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: styles.injectionTooltip__detailValue,
                    children: time
                })
            ]
        });
    }
    renderDetails() {
        return /*#__PURE__*/ _jsxs("div", {
            className: styles.injectionTooltip__details,
            children: [
                this.renderInjection(),
                this.renderTime()
            ]
        });
    }
    render() {
        return /*#__PURE__*/ _jsx("div", {
            className: styles.injectionTooltip,
            children: /*#__PURE__*/ _jsxs("div", {
                className: styles.injectionTooltip__content,
                children: [
                    this.renderTitle(),
                    /*#__PURE__*/ _jsx("div", {
                        className: styles.injectionTooltip__separator
                    }),
                    this.renderDetails(),
                    /*#__PURE__*/ _jsx(PolygonIcon, {
                        width: "17",
                        height: "12",
                        className: styles.injectionTooltip__polygon
                    })
                ]
            })
        });
    }
}
_define_property(InjectionTooltip, "propTypes", {
    // Explicit props
    injection: shapes.injection.isRequired
});
export default withStyles(styles)(InjectionTooltip);
